import React from 'react';
import BreadCrumbItem from '@/components/molecules/BreadCrumbItem';
import BreadCrumbs from '@/components/molecules/BreadCrumbs';

const OperatorModuleListBreadCrumb: React.FC = () => {
  return (
    <BreadCrumbs>
      <BreadCrumbItem title="電源指令盤管理" />
    </BreadCrumbs>
  );
};

export default OperatorModuleListBreadCrumb;
